import { Flex } from "@redotech/redo-web/flex";
import { memo } from "react";
import { ActiveConversationFilters } from "../filters/active-conversation-filters";
import { ConversationsFilterToolbar } from "../filters/conversations-filter-toolbar";
import { ConversationsTable } from "../table/components/conversations-table";

export const ConversationsTableView = memo(function ConversationsTableView() {
  return (
    <Flex
      className="h-full w-full"
      dir="column"
      gap="xl"
      overflow="hidden"
      p="lg"
    >
      <Flex dir="column" gap="xl">
        <Flex align="center" justify="space-between">
          <ConversationsFilterToolbar />
        </Flex>
        <ActiveConversationFilters />
      </Flex>
      <ConversationsTable maxHeight="calc(100vh - 270px)" />
    </Flex>
  );
});
